<app-table
  [tableColumns]="feedbackTableColumns"
  [fetchDataMethod]="feedbackFetchDataMethod"
  [paginationSize]="5"
  [usePagination]="true"
/>
